export default __webpack_public_path__ + "static/media/background_general.7337115e.svg";